export default {
    components: {

    },
    filters: {
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '過去7日',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        },
                    },
                    {
                        text: '最近一個月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        },
                    },
                    // {
                    //   text: '最近一年',
                    //   onClick(picker) {
                    //     const end = new Date()
                    //     const start = new Date()
                    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
                    //     picker.$emit('pick', [start, end])
                    //   },
                    // },
                    // {
                    //   text: '最近三個月',
                    //   onClick(picker) {
                    //     const end = new Date()
                    //     const start = new Date()
                    //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                    //     picker.$emit('pick', [start, end])
                    //   },
                    // },
                ],
            },
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        /**
       * @description 驗證是否在三個月的時間之內
       */
        async confirmDataRange(dateRange) {
            return new Promise((resolve, reject) => {
                const dateArray = [
                    new Date(dateRange[0]), // 起始時間
                    new Date(dateRange[1])  // 結束時間
                ];

                // 計算起始時間三個月之後的日期
                const startDate = new Date(dateArray[0]);
                startDate.setMonth(startDate.getMonth() + 3);

                // 將要檢查的時間與startDate做比較
                if (dateArray[1] <= startDate) {
                    resolve()
                } else {
                    this.$message.error('請選擇三個月內的時間')
                    throw new Error('請選擇三個月內的時間')
                }
            })
        },
        /**
         * @description 如果搜尋超過三個月就擋掉
         */
        async tryToFetchListFromDatePicker() {
            try {
                await this.confirmDataRange(this.filterDateRange)
                await this.tryToFetchList()
            } catch (error) {
                console.error(error.message)
            }
        },
    }
}